module.exports = __webpack_public_path__ + "img/symbol_4.8644c2fc.png";